import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'store';
import { getTenantId, getTermsandProvider } from '../../store/slices/auth';

import firebase from 'firebase/compat/app';
import { Box } from '@mui/material';
import SplashScreen from 'views/pages/SplashScreen';
import useDebounce from 'hooks/useDebounce';
// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const dispatch = useDispatch();
    const { isLoggedIn } = useAuth();
    const { tenantId } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [initialValue, setInitialValue] = useState(true);

    const location = useLocation();

    const currentUser = firebase.auth().currentUser;

    function getCookie(name: string) {
        let cookieArray = document.cookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookiePair = cookieArray[i].split('=');
            if (name === cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    }

    const isProvider = getCookie('isProvider');
    const termsAndConditions = getCookie('termsAndConditions');

    useEffect(() => {
        if (currentUser && isProvider === null && termsAndConditions === null) dispatch(getTermsandProvider());
    }, [currentUser, isProvider, termsAndConditions, dispatch]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setInitialValue(false);
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    // generar la url completa para hacer redirect
    const redirectUrl = useMemo(() => {
        return location.pathname + location.search;
    }, [location.pathname, location.search]);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate(`/loolu/admin/login?redirectUrl=${encodeURIComponent(redirectUrl)}`, { replace: true });
        } else if (!tenantId) {
            dispatch(getTenantId());
            return;
        } else if (isLoggedIn && isProvider === 'true' && termsAndConditions === 'false') {
            navigate('/loolu/admin/terms-and-conditions', { replace: true });
        }
    }, [isLoggedIn, tenantId, navigate, isProvider, termsAndConditions, redirectUrl]);

    const debounce = useDebounce(initialValue, 1000);

    // TODO: MAKE LOADING PAGE
    if (debounce) {
        return (
            <Box>
                <SplashScreen />
            </Box>
        );
    }

    return children;
};

export default AuthGuard;
